import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { AdminAction } from 'src/app/models/adminaction.model';
import { CertificateFile, UploadLayout } from 'src/app/models/settings.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { LayoutService } from 'src/app/services/layout.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';
declare const $: any;
@Component({
  selector: 'app-custom-certificate',
  templateUrl: './custom-certificate.component.html',
  styleUrls: ['./custom-certificate.component.scss']
})
export class CustomCertificateComponent  implements OnInit {
  adminActions: AdminAction[] = [];
  customCertificate: UploadLayout = {
    URLRegex: '',
    File: undefined,
    FileName: '',
    SchoolId: 0,
    Description: '',
  };
  customCertificateFiles: Array<CertificateFile> = [];

  fileToDelete: CertificateFile = {
    id: 0,
    filePath: '',
    fileName: '',
    url: '',
    inUse: false,
  };
  schId: number;

  constructor(
    public headerinfo: ComponentheaderService,
    public schoolservice: SchoolmanagementService,
    public toastr: ToastrService,
    public util: UtilService,
    public moduleservice: ModulemanagementService,
    private layoutService: LayoutService
  ) {}

  async ngOnInit() {
    try {
      this.headerinfo.pageLoadingStarted(this);
      const school: any = await this.schoolservice.getSchoolFromSubdomain();

      this.schId = school.id;
      this.customCertificate.SchoolId = this.schId;
      this.adminActions = [
        {
          displaytext: 'Upload Certificate Template',
          callback: this.popCertificateUpload.bind(this),
          classes: ['fas', 'fas fa-file-code'],
        },
        {
          displaytext: 'Download Template',
          callback: this.downloadTemplate.bind(this),
          classes: ['fas', 'far fa-file-image'],
        },
        // {
        //   displaytext: 'Test InUse Template',
        //   callback: this.testCertificate.bind(this),
        //   classes: ['fas', 'far fa-file-image'],
        // },
      ];

      this.headerinfo.setHeaderDisplay(
        'Custom Certificate ',
        [
          {
            displaytext: 'School',
            route: '/user/schoolhome',
          },
          {
            displaytext: 'Custom Certificate',
            route: `/customisation/certificate`,
          },
        ],
        this.adminActions
      );

      this.customCertificateFiles = await this.layoutService
        .getCertificateFiles(school.id)
        .then((res: any) => {
          return res;
        });
    } catch (error) {
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.customCertificate.FileName = file.name;
      this.customCertificate.File = file;
    }
  }
  popCertificateUpload() {
    $('#uploadCertificate').modal('show');
  }

  async uploadCertificateFile() {
    try {
      if (!this.checkModelValid()) {
        return;
      }
      this.headerinfo.pageLoadingStarted(this);

      let formData = new FormData();
      formData.append('File', this.customCertificate.File);
      formData.append('FileName', this.customCertificate.FileName);
      formData.append('Description', this.customCertificate.Description);
      formData.append('SchoolId', '' + this.customCertificate.SchoolId);
      formData.append('URLRegex', this.customCertificate.URLRegex);
      await this.layoutService.UploadCertificate(formData).then((res: any) => {
        this.toastr.success('File Uploaded');
        window.location.reload();
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  checkModelValid() {
    if (this.customCertificate.File == undefined) {
      this.toastr.error('No file selected');
      return false;
    }
    return true;
  }

  downloadFile(url) {
    const link = document.createElement('a');
    link.href = url;
    link.download;
    link.click();
  }
  popFileDelete(item: CertificateFile) {
    this.fileToDelete = item;
    $('#deleteFile').modal('show');
  }

  deleteCertificateFile() {
    this.layoutService.deleteCertificateFile(this.fileToDelete.id).then(() => {
      this.toastr.success('Deleted');
      window.location.reload();
    });
  }
  markCertificateFileInUse(item: CertificateFile) {
    debugger;
    this.layoutService.markCertificateFileInUse(item.id).then(() => {
      this.toastr.success('Success');
      window.location.reload();
    });
  }

  async downloadTemplate() {
    var byteFile: Uint8Array = await this.layoutService
      .getCertificateTemplate()
      .then((e: Uint8Array) => {
        return e;
      });
    const link = document.createElement('a');
    link.href = 'data:application/octet-stream;base64,' + byteFile;
    link.download = 'certificateTemplate.html';
    link.click();
  }
  async testCertificate(certId:number) {
    this.headerinfo.pageLoadingStarted(this);
    try {
      var byteFile: Uint8Array = await this.layoutService.testCertificateTemplate(this.schId,certId).then((e: Uint8Array) => {
        return e;
      });
      const link = document.createElement('a');
    link.href = 'data:application/octet-stream;base64,' + byteFile;
    link.download = 'TestCertificate.pdf';
    link.click();
    this.headerinfo.pageLoadingDone(this);
    this.toastr.success("Certificate Downloaded");
    } catch (error) {
      console.log(error);
      this.headerinfo.pageLoadingDone(this);
    }
  }
}
